"use client";

import OnlineUsers from "@/components/shared/online-users";
import UpcomingEvents from "@/modules/events/components/upcoming-events";
import FeaturedVideoCard, { FeaturedVideoCardProps } from "../featured-video-card";
import { CreateAccountCard, SubmitProductCard, TrendingNewsCard } from "../sidebar-cards";
import FeaturedNews from "./components/featured-news";
import HowToLaunch from "./components/how-to-launch/how-to-launch";
import LeadingOnlineForum from "./components/leading-online-forum/leading-online-forum";
import TodaysProducts from "./components/todays-products";
import HottestDiscussions from "../hottest-discussions";
import { TGetProducts } from "@/types/productv2";

export interface IProductListingProps {
	todayProptechLaunches: TGetProducts;
}

export const HomepageRightSidebar = (props: {
	featuredVideo: FeaturedVideoCardProps;
	enable?: {
		onlineUsers?: boolean;
		trendingNewsCard?: boolean;
		createAccountCard?: boolean;
		submitProductCard?: boolean;
	};
}) => (
	<div className="relative flex h-fit w-full flex-col gap-6 overflow-hidden rounded-lg max-lg:w-[20rem] lg:relative lg:w-80 lg:gap-10 lg:p-3">
		<div className="absolute inset-0 bg-gradient-to-b from-[rgb(0,94,255,0.07)] to-[rgba(0,94,255,0)]" />

		<FeaturedVideoCard {...props.featuredVideo} />

		{props.enable?.onlineUsers && <OnlineUsers />}
		{props.enable?.trendingNewsCard && <TrendingNewsCard />}
		{props.enable?.createAccountCard && <CreateAccountCard />}
		{props.enable?.submitProductCard && <SubmitProductCard />}
	</div>
);

function ProductListing({ todayProptechLaunches }: IProductListingProps) {
	return (
		<section className="mt-8 px-4 sm:mt-16 md:px-8">
			<div className="flex items-start justify-between gap-8 max-md:flex-wrap">
				{/* Main feed */}
				<div className="grid flex-1 gap-8 md:gap-16">
					<TodaysProducts todayProptechLaunches={todayProptechLaunches} />

					<div className="overflow-hidden">
						<HottestDiscussions />
					</div>
				</div>

				{/* Right sidebar */}
				<HomepageRightSidebar
					featuredVideo={{
						thumbnailUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/`,
						thumbnailAlt:
							"Proptech Showcase Disrupt - Managed Wi-Fi Providers Portal Launch & Demo Day 🚀",
						videoUrl:
							"https://www.youtube-nocookie.com/embed/xV6xSxeiJ5o?autoplay=1&start=0&mute=1",
						videoTitle:
							"Proptech Showcase Disrupt - Managed Wi-Fi Providers Portal Launch & Demo Day 🚀",
						text: "Proptech Showcase Disrupt - Managed Wi-Fi Providers Portal Launch & Demo Day 🚀",
					}}
					enable={{
						onlineUsers: true,
						trendingNewsCard: true,
						createAccountCard: true,
						submitProductCard: true,
					}}
				/>
			</div>

			{/* Other sections */}
			<UpcomingEvents />
			<FeaturedNews />

			<HowToLaunch />
			<LeadingOnlineForum />
		</section>
	);
}

export default ProductListing;
